<template>
  <svg fill="currentColor" :class="logoClass" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 272 12"><path d="M6.858 11.78V2.239h4.608V.22H0V2.24h4.553v9.54h2.305ZM17.258 11.78V6.826h6.249v4.954h2.323V.22h-2.323v4.606h-6.25V.22h-2.322v11.56h2.323ZM39.38 9.817h-7.115V6.826H37.5V4.88h-5.235V2.183h6.95V.22h-9.218v11.56h9.384V9.817ZM55.226 11.78V2.239h4.608V.22H48.368V2.24h4.553v9.54h2.305ZM65.626 11.78V6.826h6.25v4.954h2.322V.22h-2.323v4.606h-6.25V.22h-2.322v11.56h2.323ZM78.365.22v11.56h2.323V.22h-2.323ZM87.44.22h-2.6v11.56h2.12V3.21l6.14 8.569h2.046V.22h-2.139v7.927L87.44.22ZM110.149 11.78l-5.144-6.863L109.706.22h-2.765l-5.309 5.413V.22h-2.323v11.56h2.323V8.147l1.677-1.725 4.001 5.358h2.839ZM113.201.22v11.56h2.323V.22h-2.323ZM122.276.22h-2.599v11.56h2.12V3.21l6.138 8.569h2.047V.22h-2.139v7.927L122.276.22ZM144.763 3.156C144.044 1.174 142.219 0 139.583 0c-3.263 0-5.991 2.44-5.991 6 0 3.578 2.47 6 5.715 6 1.733 0 3.226-.734 3.797-2l.314 1.78h1.622V5.908h-5.991v1.633h3.834c-.313 1.487-1.401 2.496-3.208 2.496-2.23 0-3.687-1.56-3.687-4.037 0-2.422 1.475-3.982 3.595-3.982 1.77 0 2.839.936 3.171 2.257l2.009-1.119ZM161.264 11.78V2.239h4.608V.22h-11.466V2.24h4.553v9.54h2.305ZM171.627 2.092h3.023c1.659 0 2.397.569 2.397 1.614 0 1.083-.793 1.615-2.452 1.615h-2.968v-3.23Zm8.222 9.688v-.129c-.498-.385-.867-.99-1.18-2.825-.24-1.358-1.033-2.349-2.305-2.587 1.623-.092 2.987-1.211 2.987-2.698 0-2.018-1.42-3.32-4.369-3.32h-5.641V11.78h2.286V7.1h2.857c1.364 0 1.917.827 2.046 2.405.111 1.1.295 1.981.609 2.275h2.71ZM187.935 2.716h.074l1.733 4.44h-3.503l1.696-4.44Zm3.614 9.064h2.47L189.355.22h-2.599l-4.609 11.56h2.323l1.087-2.844h4.885l1.107 2.844ZM202.236 11.78 206.807.22h-2.433l-3.263 8.808h-.074l-3.3-8.808h-2.544l4.554 11.56h2.489ZM219.339 9.817h-7.116V6.826h5.236V4.88h-5.236V2.183h6.95V.22h-9.217v11.56h9.383V9.817ZM223.02.22v11.56h9.18V9.76h-6.857V.221h-2.323ZM235.724.22v11.56h9.18V9.76h-6.857V.221h-2.323ZM257.811 9.817h-7.115V6.826h5.235V4.88h-5.235V2.183h6.949V.22h-9.217v11.56h9.383V9.817ZM263.778 2.092h3.023c1.66 0 2.397.569 2.397 1.614 0 1.083-.793 1.615-2.452 1.615h-2.968v-3.23ZM272 11.78v-.129c-.498-.385-.866-.99-1.18-2.825-.239-1.358-1.032-2.349-2.304-2.587 1.622-.092 2.986-1.211 2.986-2.698 0-2.018-1.419-3.32-4.369-3.32h-5.641V11.78h2.286V7.1h2.857c1.365 0 1.918.827 2.047 2.405.11 1.1.295 1.981.608 2.275H272Z" /></svg>
</template>

<script>
export default {
  name: 'Logo',
  props: {
    color: {
      type: String,
      default: 'dark',
    },
    size: {
      type: String,
      default: 'large',
    },
  },
  computed: {
    logoClass() {
      return {
        'logo-small': this.size === 'small',
        'logo-large': this.size === 'large',
        'text-dark': this.color === 'dark',
        'text-light': this.color === 'light',
      };
    },
  },
};

</script>

<style lang="scss" scopped>

.logo-small {
  width: 203px;
  height: 12px;
  margin: 0 8px;
}

.logo-large {
  width: 272px;
  height: 36px;
  margin: 0 8px;
}

</style>
